export default theme => ({
  formControl: {
    width: '100%'
  }
});
